import React from "react";
import dateTimeLocales from "../constants/dateTimeLocales";
import { PageContextProps } from "./Layout";
import { getEventDateTime } from "../helpers/dateTimeDatoString";

interface Props {
  from: string;
  to: string | null;
  locale: PageContextProps["locale"];
}

const DateTime = ({ from, to, locale }: Props) => {
  const getDateTimeLocale = (locale: string) => {
    const supportedDateTimeLocales = Object.keys(dateTimeLocales);
    const defaultDateTimeLocale = supportedDateTimeLocales.find(
      (dateTimeLocale) => dateTimeLocales[dateTimeLocale].default
    );
    const activeDateTimeLocale = supportedDateTimeLocales.find(
      (dateTimeLocale) => dateTimeLocales[dateTimeLocale].locale === locale
    );

    return activeDateTimeLocale ? activeDateTimeLocale : defaultDateTimeLocale;
  };

  const dateTimeLocale = getDateTimeLocale(locale);
  const eventDateTime = getEventDateTime(from, to, dateTimeLocale);

  return <div>{eventDateTime}</div>;
};
export default DateTime;
